import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ISTAT_MILANO } from 'shell/constants/istat-milano';

export const MilanMuncipality: MunicipalityAnprVM = {
  id: ISTAT_MILANO,
  description: 'MILANO',
  province: 'MI',
  provinceCode: 'MI',
};
